import { RelationType } from '../enums/relation-type';
import { Serializable } from './serializable';

export class Pairing implements Serializable<Pairing> {
  private _id: string = '';
  public relationType: RelationType = RelationType.PARENT;
  public creationDate: Date = null;
  public sourceUserId: string = '';
  public targetUserId: string = '';

  /**
   * Gets entity id
   * @returns entity id
   */
  public getId(): string {
    return this._id;
  }

  /**
   * Transforms received object to Pairing entity
   * @param input
   * @returns Pairing entity
   */
  public deserialize(input: any = {}): Pairing {
    if (!input) {
      return null;
    }

    const properties = Object.getOwnPropertyNames(this);
    Object.keys(input).forEach((key) => {
      if (input[key] !== null) {
        switch (key) {
          case 'id':
            this._id = input[key];
            break;
          case 'creationDate':
            this[key] = new Date(input[key]);
            break;
          default:
            if (properties.includes(key)) {
              this[key] = input[key];
            }
            break;
        }
      }
    });

    return this;
  }

  /**
   * Transforms Pairing entity to json object
   * @returns json object
   */
  public serialize(): any {
    const output = {};

    Object.getOwnPropertyNames(this).forEach((property) => {
      switch (property) {
        case '_id':
          if (this[property]) {
            output['id'] = this[property];
          }
          break;
        case 'creationDate':
          output[property] =
            this[property] != null ? this[property].toString() : this[property];
          break;
        default:
          output[property] = this[property];
          break;
      }
    });

    return output;
  }
}
